/**
 * BC Legível — dois comportamentos pequenos e isolados, para o lojista não se perder no celular:
 *  1. faixa do topo dinâmica: diz quanto falta para o pedido mínimo e para o próximo preço por peça;
 *  2. dica «Toque no número para digitar» acima da grade de tamanhos (página de produto e janela de compra rápida).
 * Carregar DEPOIS do bc-atacado.js (snippets/bc-atacado-head.liquid), com defer. Não altera carrinho, checkout nem preços:
 * só lê /cart.js e o cartão «Seu pedido» que o servidor já renderiza ([data-bc-progresso], seção bc-progresso).
 */
(function () {
  'use strict';
  if (window.BCLegivel) return;

  var CFG = window.BCAtacadoConfig || {};
  var RAIZ = (CFG.urlRaiz || '/').replace(/\/$/, '');
  var MINIMO = CFG.minimoCentavos || 0;
  var FAIXAS = (CFG.faixas || []).slice().sort(function (a, b) { return a.qtd - b.qtd; });

  function dinheiro(c) {
    if (window.BCAtacado && window.BCAtacado.dinheiro) return window.BCAtacado.dinheiro(c);
    var p = (Math.abs(c) / 100).toFixed(2).split('.');
    return (c < 0 ? '-' : '') + 'R$ ' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }
  /** «R$ 299» quando não há centavos (o mínimo), senão o valor completo. */
  function dinheiroCurto(c) {
    return c % 100 === 0 ? dinheiro(c).replace(/,00$/, '') : dinheiro(c);
  }
  function proximaFaixa(pecas) {
    for (var i = 0; i < FAIXAS.length; i++) if (pecas < FAIXAS[i].qtd) return FAIXAS[i];
    return null;
  }

  /* ---------- 1. faixa do topo ---------- */

  /** O parágrafo da faixa que fala do mínimo (ou o primeiro). Guarda o texto original para voltar se algo falhar. */
  function faixaTopo() {
    var ps = document.querySelectorAll('.announcement-bar__message p');
    if (!ps.length) return null;
    for (var i = 0; i < ps.length; i++) if (/m[ií]nimo/i.test(ps[i].textContent) || ps[i].hasAttribute('data-bcl-faixa')) return ps[i];
    return null;
  }

  // espaço não separável: a faixa pode quebrar em duas linhas no celular, mas nunca em «R$ / 31,90» ou «10 / peças»
  var NB = ' ';
  function valor(c) { return dinheiro(c).replace(' ', NB); }

  function precoPorPeca(pecas) {
    if (window.BCAtacado && window.BCAtacado.precoPorPeca) return window.BCAtacado.precoPorPeca(pecas);
    var p = CFG.precoBase || 0;
    FAIXAS.forEach(function (f) { if (pecas >= f.qtd) p = f.preco; });
    return p;
  }

  // Textos curtos, de uma linha em 390 px (revisão leiga, item 7). Na página de produto com o cartão «Seu pedido»,
  // o cartão já diz quanto falta: ali a faixa do topo fica neutra e estática (uma informação num lugar só).
  // A página é reconhecida pelo template (meta.page.pageType do Shopify) e pela grade principal do produto, nunca por
  // um cartão parecido que a gaveta ou a janela rápida possam trazer. Kit (produto sem grade) continua dinâmico.
  var PAGINA_PRODUTO = (function () {
    var tipo = window.meta && window.meta.page && window.meta.page.pageType;
    if (tipo) return tipo === 'product';
    return /\/products\//.test(location.pathname);
  })();
  function noProduto() {
    if (!PAGINA_PRODUTO) return false;
    var gs = document.querySelectorAll('.product-form bc-grade:not([data-bc-rapida])');
    for (var i = 0; i < gs.length; i++) if (!gs[i].closest('#mini-cart, .mini-cart, quick-buy-popover, quick-buy-drawer, .quick-buy-modal')) return true;
    return false;
  }
  function textoNeutro() { return 'Mínimo ' + dinheiroCurto(MINIMO).replace(' ', NB) + ' · misture modelos'; }
  function textoFaixa(total, pecas, itens) {
    if (noProduto() || !itens) return textoNeutro();
    if (total < MINIMO) return 'Faltam ' + valor(MINIMO - total) + ' para o mínimo';
    var prox = proximaFaixa(pecas);
    if (pecas > 0 && prox) return '✓ Mínimo atingido · faltam ' + (prox.qtd - pecas) + NB + 'p/' + NB + valor(prox.preco);
    if (pecas > 0) return '✓ Mínimo atingido · melhor preço';
    return '✓ Mínimo atingido';
  }

  // Estado: a sacola (servidor) e, na página de produto, o que está escolhido na grade principal.
  // A conta é a mesma do cartão: total = sacola − ganho da sacola ao mudar de faixa + estimado da grade.
  var sacola = null;
  var grade = { pecas: 0, total: 0, elegivel: false };

  function pintar() {
    var p = faixaTopo();
    if (!p || !MINIMO || !sacola) return;
    if (!p.hasAttribute('data-bcl-faixa')) {
      p.setAttribute('data-bcl-faixa', '');
      p.setAttribute('aria-live', 'polite');
    }
    var novas = grade.elegivel ? grade.pecas : 0;
    var pecas = sacola.pecas + novas;
    var ganho = sacola.pecas * Math.max(0, precoPorPeca(sacola.pecas) - precoPorPeca(pecas));
    var total = sacola.total - ganho + grade.total;
    var t = textoFaixa(total, pecas, sacola.itens + grade.pecas);
    if (p.textContent !== t) p.textContent = t;
  }

  function pintarFaixa(total, pecas, itens) {
    sacola = { total: total, pecas: pecas, itens: itens };
    pintar();
  }

  // a grade principal do produto avisa a cada mudança (bc-atacado.js); a janela de compra rápida (rapida) não entra
  document.addEventListener('bc:grade-alterada', function (e) {
    var d = e.detail || {};
    if (d.rapida) return;
    var g = document.querySelector('.product-form bc-grade:not([data-bc-rapida])');
    grade = { pecas: d.pecas || 0, total: d.total || 0, elegivel: !!(g && g.getAttribute('data-elegivel') === 'true') };
    pintar();
  });

  /** Peças que contam para o preço por quantidade: lidas do cartão do servidor quando ele está em dia com a sacola. */
  function pecasDoServidor(carrinho) {
    var bs = document.querySelectorAll('[data-bc-progresso]');
    for (var i = 0; i < bs.length; i++) {
      if (bs[i].getAttribute('data-total') === String(carrinho.total_price) && bs[i].getAttribute('data-itens') === String(carrinho.item_count)) {
        return Promise.resolve(parseInt(bs[i].getAttribute('data-pecas'), 10) || 0);
      }
    }
    if (!carrinho.item_count) return Promise.resolve(0);
    return fetch(RAIZ + '/?sections=bc-progresso', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var m = j && j['bc-progresso'] && j['bc-progresso'].match(/data-pecas="(\d+)"/);
        return m ? parseInt(m[1], 10) : 0;
      });
  }

  var pedido = 0;
  function atualizarFaixa(carrinho) {
    if (!faixaTopo() || !MINIMO) return;
    var meu = ++pedido;
    var obter = carrinho && typeof carrinho.total_price === 'number'
      ? Promise.resolve(carrinho)
      : fetch(RAIZ + '/cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    obter
      .then(function (c) { return pecasDoServidor(c).then(function (pecas) { return { c: c, pecas: pecas }; }); })
      .then(function (x) { if (meu === pedido) pintarFaixa(x.c.total_price, x.pecas, x.c.item_count); })
      .catch(function () { /* a faixa fica como está */ });
  }

  function aoMudar(e) {
    clearTimeout(aoMudar._t);
    var c = e && e.detail && e.detail.cart;
    // espera o bc-atacado.js e o tema trocarem o cartão do servidor, para ler data-pecas já atualizado
    aoMudar._t = setTimeout(function () { atualizarFaixa(c && c.items ? c : null); }, 600);
  }
  document.documentElement.addEventListener('cart:updated', aoMudar);
  document.documentElement.addEventListener('cart:refresh', aoMudar);

  /* ---------- 2. dica de digitação na grade ---------- */

  var TOQUE = window.matchMedia ? window.matchMedia('(hover: none), (pointer: coarse)').matches : false;
  function dicas() {
    // só em tela de toque: no desktop o campo já mostra o cursor de texto e a dica empurraria a grade para fora dos 768 px
    if (!TOQUE) return;
    var gs = document.querySelectorAll('bc-grade:not([data-bcl-dica])');
    for (var i = 0; i < gs.length; i++) {
      var g = gs[i], cab = g.querySelector('.bc-grade__cab');
      if (!cab) continue;
      g.setAttribute('data-bcl-dica', '');
      var p = document.createElement('p');
      p.className = 'bcl-dica';
      p.textContent = 'Toque no número para digitar a quantidade';
      cab.parentNode.insertBefore(p, cab.nextSibling);
    }
  }
  var agendado = false;
  function agendarDicas() {
    if (agendado) return;
    agendado = true;
    (window.requestAnimationFrame || setTimeout)(function () { agendado = false; dicas(); });
  }

  function iniciar() {
    dicas();
    // a janela de compra rápida monta a grade depois; observa só a chegada de novos <bc-grade>
    if (window.MutationObserver) {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { agendarDicas(); return; }
      }).observe(document.body, { childList: true, subtree: true });
    }
    atualizarFaixa(null);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();

  window.BCLegivel = { atualizarFaixa: atualizarFaixa };
})();
